import { t } from "i18next";
import style from "./Slide.module.scss";
import SlideWrapper from "./SlideWrapper";

interface AkcizniProizvodiProps {
  goBackHandler: () => void;
}

const AkcizniProizvodi = ({ goBackHandler }: AkcizniProizvodiProps) => {
  return (
    <SlideWrapper
      title={t("LOGIN.AKCIZNI_PROIZVODI")}
      goBackHandler={goBackHandler}
    >
      <p className={style.cardText}>{t("LOGIN.AKCIZNI_PROIZVODI_PARAGRAPH")}</p>
    </SlideWrapper>
  );
};

export default AkcizniProizvodi;
